import { SCENARIO_EP } from "utils/constants/coreConstants";
import { PC } from "utils/constants/descriptorTypes";


//TODO Filtrar substâncias perigosas no produto

/**
 * Three arguments changed when the payloads flattened, and each one took the
 * place of what it replaced rather than being added beside it:
 *
 *   productComposition   <- product.product_raw_materials (the rows of one product)
 *   mixturesBySubstance  <- rawMaterial.mixtures (mixture_substance by substance_id)
 *   descriptorsById      <- scenario.descriptors, which is now a list of ids
 *
 * A caller that still passes the old value throws on the first line that uses it,
 * which is what should happen: none of the three can be told apart by looking.
 */
export default (
    productComposition, typesOfProducts, lcsUse, scenarios, shipmentsById, mixturesBySubstance, descriptorsById
) => {

    const dangerousSubstancesIds = productComposition
        .filter(s => s.contributes_to_hazard)
        .map(s => s.raw_material_id);

    // Filtra cenários CEDEMP
    const filteredScenariosLists = [];

    dangerousSubstancesIds.forEach(dsID => {
        filteredScenariosLists.push(
            scenarios.filter(sc =>
                sc.type === SCENARIO_EP &&
                dangerousSubstancesIds.includes(sc.substance_id) &&
                sc.raw_material_supplier_id &&
                lcsUse.id === parseInt(sc.lcs_id) &&
                (
                    dsID === shipmentsById[sc.raw_material_supplier_id].raw_material_id ||
                    (mixturesBySubstance[dsID] || [])
                        .map(mix => mix.mixture_id)
                        .includes(shipmentsById[sc.raw_material_supplier_id].raw_material_id)
                )
            )
        );
    });

    let flatFilteredScenarios = [];

    filteredScenariosLists.forEach(scenarioList => {
        const relevantScenarios = scenarioList.filter( sc => (
            sc.descriptors.length > 0  &&
            sc.descriptors.some(dscId => {
                const dsc = descriptorsById[dscId];
                return dsc.descriptor_type_id === PC && typesOfProducts.includes(dsc.code);
            })
        ));
        flatFilteredScenarios = flatFilteredScenarios.concat(relevantScenarios);
    });

    return flatFilteredScenarios;
};



